import { render } from "./DashboardLayout.vue?vue&type=template&id=6253ecfd&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=6253ecfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6253ecfd"],['__file',"src/pages/Layout/DashboardLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6253ecfd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6253ecfd', __exports__)) {
    api.reload('6253ecfd', __exports__)
  }
  
  module.hot.accept("./DashboardLayout.vue?vue&type=template&id=6253ecfd&scoped=true", () => {
    api.rerender('6253ecfd', render)
  })

}


export default __exports__